{
  "name": "@homer.core/user",
  "version": "1.37.0",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.adapter/deepobjectdiff": "*",
    "@homer.api/homer": "*",
    "@homer.core/application": "*",
    "@homer.core/channel": "*",
    "@homer.core/email": "*",
    "@homer.core/emitter": "*",
    "@homer.core/scheduler": "*",
    "@homer.core/storage.cookie": "*",
    "@homer.core/storage.local": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
